import { ISchemeChartData } from '@/src/common/types';
import React from 'react';
import { TooltipProps } from 'recharts';
import styled from 'styled-components';

interface CustomTooltipProps extends TooltipProps<string, string> {
  textColor?: string;
}

const TooltipContainer = styled.div`
  display: flex;
  font-size: 1rem;
  font-weight: 400;
  font-family: Roboto Condensed;
  align-items: center;
  text-align: center;
  background-color: #eaeaea;
  padding: 3px;
  line-height: 1rem;
  border: 1px solid #eaeaea;
  @media (max-width: 768px) {
    font-size: 0.6rem;
    padding: 2px;
    line-height: 0.7rem;
  }
`;

const Price = styled.p<{ textColor?: string }>`
  text-align: left;
  padding-right: 0.2rem;
  margin-right: 0.2rem;
  color: ${(props) => props.textColor || '#000'};
  @media (max-width: 768px) {
    padding-right: 0rem;
    margin-right: 0rem;
  }
`;

const FormattedDate = styled.p<{ textColor?: string }>`
  text-align: right;
  padding-left: 0.2rem;
  margin-left: 0.2rem;
  color: ${(props) => props.textColor || '#000'};
  @media (max-width: 768px) {
    padding-right: 0rem;
    margin-right: 0rem;
  }
`;

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

const CustomTooltip = ({ active, payload, textColor }: CustomTooltipProps) => {
  if (active && payload && payload.length) {
    const data: ISchemeChartData = payload[0].payload;
    const formattedDate = formatDate(data.NAVDATE);

    return (
      <TooltipContainer className="custom-tooltip">
        <Price textColor={textColor}>NAV: ₹{data.NAVRS.toFixed(2)}</Price> |
        <FormattedDate textColor={textColor}>{formattedDate}</FormattedDate>
      </TooltipContainer>
    );
  }
  return null;
};

export default CustomTooltip;
